import { makeStyles } from '@material-ui/core/styles';

import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  badge: {
    backgroundColor: theme.colorPalette.green_80,
    borderRadius: theme.spacing(5),
    color: theme.colorPalette.white,
    fontSize: 16,
    padding: theme.spacing(2, 4),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    maxWidth: 160,
    fontWeight: 600,
    ...reskinStyles(theme, theme.labelStyles.outlined)
  }
});

export default makeStyles(styles);
